<template>
  <section class="content-actions" v-if="is_loggin && !isFullLayout" :style="{ bottom: y >= 250 ? '5%' : '5%' }">

    <section class="btn-actions" :class="{ 'show': isShowOption, 'scroll': y > 250 }">

      <b-button variant="primary" class="mb-1 actions" size="sm" title="Vídeos de  Ayuda" @click="() => showApoyo = true">
        <font-awesome-icon icon="fas fa-info-circle" size="lg" />
      </b-button>

      <template v-for="(item, i) in actionsItems" :key="i">
        <b-button  variant="primary" class="mb-1 actions" size="sm" :title="item.title"
          @click="ir_actions(item.action)" :alt="item.title">
          <font-awesome-icon :icon="item.icon" size="lg" />
        </b-button>
      </template>
      <!-- <b-button v-for="({ icon, title, action,permiso }, i) in actionsItems" variant="primary" class="mb-1 actions" size="sm" :title="title"
        @click="ir_actions(action)" :alt="title"   v-if="$can('read',permiso)">
        <font-awesome-icon :icon="icon" size="lg" />
      </b-button> -->
    </section>


    <div class="btn-fijo">
      <b-button variant="primary" class="rounded" @click="toggleOptions">
        <font-awesome-icon :icon="['fas', !isShowOption ? 'fa-plus' : 'fa-minus']" size="2x" />
      </b-button>
    </div>



  </section>

</template>


<script setup>

  import { toRefs, ref, computed, inject } from 'vue'
  import { useWindowScroll } from '@vueuse/core'
  import useAuth from '@utils/useAuth';
  import { useRouter,useRoute } from 'vue-router';
  const showApoyo = inject('showApoyo');

  const props = defineProps({
    actionsItems:{
      type:[Array],
      default: (r) => ([
        {icon:'fab fa-rocketchat' ,permiso:'Chat',title:"Chat", action:(r) => r.push({name:'chat'} )},
        
      ])
    }
  });

  const isShowOption = ref(false)

  const { y } = useWindowScroll()
  

  const {
    is_loggin
  } = useAuth();

const toggleOptions = () => isShowOption.value = !isShowOption.value
const route = useRoute();

const isFullLayout = computed(() => {
  return route.meta.layout === 'full';
})


const cant_items = computed(() => props.actionsItems.length)
const router = useRouter();

const ir_actions = (next) => {
  next(router);
} 

</script>

<style lang="scss" scoped>

$items:v-bind(cant_items);

.content-actions {
  position: fixed;
  right: 16px;
  z-index: 1010;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 50px;
  transition: all 30ms ease;
  padding: 0px;
  .btn-actions{
    width:40px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    transition: all .5s ease;
    position:fixed;
    bottom: 5%;
    overflow-y: hidden;
    flex-wrap: nowrap !important;
    max-height: 40px;

    &.show{
      transition: all .5s ease;
      transform:translateY(-#{calc((50px + 40px) * #{$items})});
      margin-bottom:60px;
      display:flex;
      max-height:auto !important;
      overflow-y: hidden;
      height:auto;
      max-height: calc(50px * (#{$items} + 1));
    }

    .btn{
      padding: .2rem;
      transition: all .5s ease;
      position: relative;
      flex: 0 1 40px;

      &:hover{
        transition: all .5s ease;
      }
    }
  }


  .btn-fijo {
    z-index: 98;
    position: relative;
    transition: all .5s ease;
    z-index: 1050 !important;
    
    &.scroll {
      bottom: 12%;
    }

    &.show {
      transition: all .5s ease;
    }

    .btn {
      height: 50px;
      width: 50px;
      padding: 0px;
      transition: all ease-in 60ms;

      svg {
        opacity: 0.7;
      }

      &:hover>svg {
        opacity: 1;
      }

      &:hover {
        height: 55px;
        width: 55px;
        transition: all ease-in-out 60ms;
      }

    }
    
  }
  
}
</style>